/* import __COLOCATED_TEMPLATE__ from './notifications-denied-modal.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class NotificationsDeniedModal extends Component {
  @service modalService;
  @action
  closeModal() {
    this.modalService.closeModal();
  }
}
